<template>
  <div class="resume-skills-wrapper">
    <div v-for="skill in skills" :key="skill.id" class="skill">
      <img :src="skill.icon" :class="{'full-icon': !skill.text}" class="skill-icon" alt="skill icon"/>
      <span v-if="skill.text" class="skill-text">{{ skill.text }}</span>
    </div>
  </div>
</template>

<script>

import ResumeItem from "@/models/ui/ResumeItem";

export default {
  name: "ResumeSkills",
  data: () => ({
    skills: [
      new ResumeItem(0, 'vue', 'Vue.js', require('../../../assets/img/icons/skills/ic_vue.svg')),
      new ResumeItem(1, 'javaScript', 'JavaScript', require('../../../assets/img/icons/skills/ic_javascript.svg')),
      new ResumeItem(2, 'scss', 'SCSS/SASS', require('../../../assets/img/icons/skills/ic_sass.svg')),
      new ResumeItem(3, 'html', 'HTML', require('../../../assets/img/icons/skills/ic_html.svg')),
      new ResumeItem(4, 'pwa', 'PWA', require('../../../assets/img/icons/skills/ic_pwa.svg')),
      new ResumeItem(5, 'bitbucket', '', require('../../../assets/img/icons/skills/bitbucket-blue.svg')),
      new ResumeItem(6, 'confluence', '', require('../../../assets/img/icons/skills/confluence-blue.svg')),
      new ResumeItem(7, 'jira', '', require('../../../assets/img/icons/skills/jira-software-blue.svg')),
    ]
  }),
  methods: {},
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";

.resume-skills-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.skill {
  align-items: center;
  display: flex;
  filter: grayscale(100%);
  margin-bottom: 15px;
  margin-right: 25px;
  transition: filter 0.2s ease-in-out;
  user-select: none;
  -webkit-filter: grayscale(100%);

  &-icon {
    margin-right: 10px;
    width: 30px;

    &.full-icon {
      width: 95px;
    }
  }

  &-text {
    font-size: 16px;
  }

  @include on-hover {
    -webkit-filter: grayscale(0);
    filter: grayscale(0);
  }
}

@media screen and (min-width: $screen-md) {
  .resume-skills-wrapper {
  }

  .skill {
    &-icon {
      width: 40px;

      &.full-icon {
        width: 110px;
      }
    }


    &-text {
      font-size: 18px;
    }
  }
}
</style>
